import { updateEntities } from 'redux-query';

import { formatPracticeAddress } from 'utils/practice';
import { Dispatch, PracticeInfo, PracticesState } from 'types';

export const fetchPracticeLocation =
  (practiceInfo: PracticeInfo) =>
  (dispatch: Dispatch): void => {
    if (!google.maps) {
      throw new Error('Google maps javascript api was not loaded correctly');
    }

    const geocoder = new google.maps.Geocoder();
    geocoder.geocode(
      { address: formatPracticeAddress(practiceInfo).replace(' ', '+') },
      (results): void => {
        if (results?.length) {
          dispatch(
            updateEntities({
              practices: (prevPractices: PracticesState): PracticesState => ({
                ...prevPractices,
                [practiceInfo.id]: {
                  ...prevPractices[practiceInfo.id],
                  lat: results[0].geometry.location.lat(),
                  lng: results[0].geometry.location.lng(),
                },
              }),
            }),
          );
        }
      },
    );
  };
